import React from 'react';

function SyntaxCard(props) {
    const { tlTitle, tlList, brTitle, brList } = props;

    return (
    <div className="syntaxCardInner">
        <div className='cardTopContainer'>
        <h1 className='cardH1'>
            {tlTitle}
        </h1>
            <ul className="cardUl">
            {tlList && tlList.map((obj, index) => {
                return(
                    <React.Fragment key={index}>{obj}</React.Fragment>
                );
            })}
            </ul>
        </div>
        <div className='cardBottomContainer'>
        <h1 className='cardH1'>
            {brTitle}
        </h1>
            <ul className="cardUl">
            {brList && brList.map((obj, index) => {
                return(
                    <React.Fragment key={index}>{obj}</React.Fragment>
                );
            })}
            </ul>
        </div>
    </div>
    )
}

export default SyntaxCard;
